import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-confirm-reservation-dialog',
  templateUrl: './confirm-reservation-dialog.component.html',
  styleUrls: ['./confirm-reservation-dialog.component.sass']
})
export class ConfirmReservationDialogComponent implements OnInit {

  catalogue_ID: any
  schools: any
  public cancel: boolean = false

  disableAccept: boolean = false

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private translate: TranslateService, private dataService: DataService) {

    if (data.showSchools) {
      this.catalogue_ID = data.showSchools
    }

    if(data.cancel) {
      this.cancel = true
    }

    console.log(data.total_messages) 
    if(data.total_messages == 0) {
      console.log("boton desabilitado")
      this.disableAccept = true
    }
    


  }

  ngOnInit(): void {
    if (this.catalogue_ID) {
      this.dataService.getCatalogueSchoolRelations({ catalogue_id: this.catalogue_ID }).subscribe(res => {
        this.schools = res
      })

    }



  }

}
